import { NgModule } from '@angular/core';
import { CreditBlockedModule } from './misc/credit-blocked/credit-blocked.module';
import { SiteContextSelectorModule } from './misc/site-context-selector';

@NgModule({
  imports: [CreditBlockedModule, SiteContextSelectorModule],
})
export class CmsLibModule {}
